import React, { useState , useEffect, useContext } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import '../royal.css';
import CelebrityBanner1 from "../assets/celebrity_banner_2 (3).jpg";
import CelebrityBanner2 from "../assets/CC-Website-Banner-01.jpg";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Deal from "./Deal";
import Dealdata from "./Dealdata";
import { faStar} from '@fortawesome/free-solid-svg-icons';
// import Pack from'../assets/Island_Trip.jpg' ;
// import Cruise from '../assets/Cruise.jpg';
// import Entertain from '../assets/Entertain.jpg';
// import Island from '../assets/Island_Trip.jpg';
// import Record from '../assets/Guiness_Record.jpg';
// import Family from '../assets/Family.jpg';
// import Activity from'../assets/Activity2.jpg';
// import Celebrityship from '../assets/CEL_BY_Celebrity_Suite_Living_Room_ 1.jpg'
// import VipSuite from '../assets/vipsuite.jpg'
// import Interior from '../assets/Interior.jpg'
// import Ocean from '../assets/Oceanview.jpg'
// import Balcony from '../assets/Balcony.jpg'
// import Suite from '../assets/Suite.jpg4
import Sailing from '../assets/CEL_AT_Santorini_Lifestyle.jpg';
import Spa from '../assets/Spa.jpg';
import Wine from '../assets/CEL_Florence_Wine_Tasting_3.jpg';
import Chef from '../assets/CEL_EC_Chefs.jpg';
import Guest from '../assets/CEL_CS_Pool_Deck_Service_1.jpg';
import CInterior from '../assets/CEL_AT_Champagne_1.jpg';
// import Infinite from '../assets/CEL_AT_Infinite_Veranda_2.jpg';
import Veranda1 from '../assets/veranda1.jpg';
import Veranda2 from '../assets/veranda2.jpg';
import SkySuite1 from "../assets/CEL_EG_Sky_Suite_Bedroom.jpg";
import SkySuite2 from '../assets/CEL_EG_Sky_Suite_Balcony.jpg';
// import Edgevilla from '../assets/CEL_BY_Edge_Villa_Living_Room_1.jpg';
import Edgevilla1 from '../assets/CEL_EG_Edge_Villa_Bedroom.jpg';
import Edgevilla2 from '../assets/CEL_EG_Edge_Villa_Living_Room_4.jpg';
import Edgevilla3 from '../assets/CEL_EG_Edge_Villa_Balcony.jpg';
import Penthouse1 from '../assets/CEL_ML_Penthouse_Suite_Bedroom.jpg';
import Penthouse2 from '../assets/CEL_ML_Penthouse_Suite_Living_Room_2.jpg';
import Penthouse3 from '../assets/CEL_ML_Penthouse_Suite_Balcony_1.jpg';
// import Penthouse from '../assets/CEL_ML_Penthouse_Suite_Living_Room_1.jpg';
// import Iconic from '../assets/CEL_EG_Iconic_Suite_Living_Room_3.jpg';
import CelebrityForm from "./CelebrityLeadForm";
import { ReactComponent as Next } from '../assets/next.svg';
import { ReactComponent as Pre } from '../assets/pre.svg';
import ISMaster from "../assets/CEL_EG_Iconic_Suite_Master_Bedroom.png";
import ISLiving from "../assets/CEL_EG_Iconic_Suite_Living_Room_3 (1).png";
import ISBed from "../assets/CEL_AX_Iconic_Suite_Bedroom.png";
import ISBalcony from "../assets/CEL_EG_Iconic_Suite_Balcony.png";
import ScrolltoTop from "./ScrolltoTop";
import CelebrityOffer1 from "../assets/CEL_BY_Retreat_Sundeck.jpg";
import CelebrityOffer2 from '../assets/CEL_EG_Martini_Bar1.jpg';
// import CelebrityOffer3 from '../assets/CEL_EG_Martini_Bar2.jpg';
import CelebrityOffer4 from '../assets/CEL_BY_Eden_Restaurant1.jpg';
// import CelebrityOffer5 from '../assets/CEL_BY_Eden_Restaurant2.jpg';
import CelebrityOffer6 from '../assets/CEL_EG_Magic_carpet.jpg';
import CelebrityOffer7 from '../assets/CEL_EG_Resort_Deck.jpg';
import UtmUpdate from "./WhatsAppUTMLinkUpdater";
import { CurrencyContext } from "./CurrencyContext";


const dlink = {
  banner1:{
    USD:"https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&cruiseline=2&destinationtype=All&sortColumn=cruiselinePriority&sortOrder=asc",
    INR:"https://booking.tirun.com/swift/cruise?siid=1113842&lang=1&cruiseline=2&destinationtype=All&sortColumn=cruiselinePriority&sortOrder=asc"
  },
  banner2:{
    USD:"https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&cruiseline=2&destinationtype=All&sortColumn=cruiselinePriority&sortOrder=asc",
    INR:"https://booking.tirun.com/swift/cruise?siid=1113842&lang=1&cruiseline=2&destinationtype=All&sortColumn=cruiselinePriority&sortOrder=asc"
  }
}


const Celebrity = () => {

  const Currency = useContext(CurrencyContext);

  const [index, setIndex] = useState(0); // initial slide index
  const [cardsPerView, setCardsPerView] = useState(2);

  // Array of only the selected deals
  const selectedDeals = [Dealdata[4], Dealdata[8], Dealdata[81], Dealdata[82], Dealdata[83], Dealdata[84]];

  useEffect(() => {
    const updateCardsPerView = () => {
      setCardsPerView(window.innerWidth < 768 ? 1 : 2);
    };
    updateCardsPerView();
    window.addEventListener('resize', updateCardsPerView);
    return () => window.removeEventListener('resize', updateCardsPerView);
  }, []);


  const maxIndex = selectedDeals.length - cardsPerView;

  const handlePrev = () => {
    setIndex((prev) => (prev <= 0 ? maxIndex : prev - 1));
  };
  
  const handleNext = () => {
    setIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
  };

  const visibleDeals = selectedDeals.slice(index, index + cardsPerView);


  // expedition

  const [eindex, esetIndex] = useState(0); // initial slide index

  const [ecardsPerView, esetCardsPerView] = useState(2);


  // Array of only the selected deals
  const eselectedDeals = [Dealdata[85], Dealdata[10], Dealdata[18]];

  useEffect(() => {
    const eupdateCardsPerView = () => {
      esetCardsPerView(window.innerWidth < 768 ? 1 : 2);
    };
    eupdateCardsPerView();
    window.addEventListener('resize', eupdateCardsPerView);
    return () => window.removeEventListener('resize', eupdateCardsPerView);
  }, []);

  const emaxIndex = eselectedDeals.length - ecardsPerView;

  const ehandlePrev = () => {
    esetIndex((prev) => (prev <= 0 ? emaxIndex : prev - 1));
  };
  
  const ehandleNext = () => {
    esetIndex((prev) => (prev >= emaxIndex ? 0 : prev + 1));
  };

  const evisibleDeals = eselectedDeals.slice(eindex, eindex + ecardsPerView);

  // celebrity cruise

  const [ccindex, ccsetIndex] = useState(0); // initial slide index
  
   const [cccardsPerView, ccsetCardsPerView] = useState(2);

  // Array of only the selected deals
  const ccselectedDeals = [Dealdata[11], Dealdata[12], Dealdata[20], Dealdata[21] , Dealdata[22], Dealdata[23], Dealdata[24], Dealdata[25], Dealdata[26], Dealdata[27], Dealdata[28], Dealdata[29], Dealdata[30], Dealdata[31], Dealdata[32]];

  useEffect(() => {
    const ccupdateCardsPerView = () => {
      ccsetCardsPerView(window.innerWidth < 768 ? 1 : 2);
    };
    ccupdateCardsPerView();
    window.addEventListener('resize', ccupdateCardsPerView);
    return () => window.removeEventListener('resize', ccupdateCardsPerView);
  }, []);

  const ccmaxIndex = ccselectedDeals.length - cccardsPerView;

  const cchandlePrev = () => {
    ccsetIndex((prev) => (prev <= 0 ? ccmaxIndex : prev - 1));
  };
  
  const cchandleNext = () => {
    ccsetIndex((prev) => (prev >= ccmaxIndex ? 0 : prev + 1));
  };

  const ccvisibleDeals = ccselectedDeals.slice(ccindex, ccindex + cccardsPerView);

    return(
        <>

        <UtmUpdate/>
        
        <Navbar/>
        <div className="header">
            <div className="offer-alert">
                <div>
                    <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                    <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                    <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                    <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                    <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                </div>
                <p>4.8 Overall Rating and 5,00,000+ happy customers</p>
            </div>


            <div class= "ajslider celebrity-slider-main">
           
     <div id="carouselExampleIndicators" class="carousel slide royal-header"  data-bs-ride="carousel" data-bs-interval="2000">

         
   <div class="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
   {/* <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button> */}
    {/* <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button> */}
  </div>

  <div class="carousel-inner celebrity-inner">

    <div class="carousel-item active ">
    <a href={dlink.banner1[Currency.currencyCode]} target="_self" rel="noopener noreferrer">
      <img src={CelebrityBanner2} class="d-block w-100 " alt="..." style={{ height:'82vh'}}/>
    </a>
    </div>

    <div class="carousel-item ">
    <a href={dlink.banner2[Currency.currencyCode]} target="_self" rel="noopener noreferrer">
      <img src={CelebrityBanner1} class="d-block w-100 " alt="..." style={{ height:'82vh'}}/>
    </a>
    </div>
    {/* <div class="carousel-item mobile">
      <img src={mobile1} class="d-block w-100" alt="..."/>
    </div> */}
    {/* <div class="carousel-item mobile">
      <img src={mobile2} class="d-block w-100" alt="..."/>
    </div> */}

  </div>

 
  {/* <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button> */}

</div>


<div>
  <CelebrityForm />
  </div>

</div>

</div>




    



        <div className="royal-caribbean celebrity-cruise-container">
            <p>You’ll Never Want To Vacation Any Other Way <br></br><br></br>Step aboard Celebrity Cruises, where world-class service meets the world’s most iconic destinations. Indulge in Michelin-starred chef-crafted menus, spacious accommodations with intuitive design, and thoughtful service that feels like it is made just for you.</p>
            <p>When you cruise with Celebrity Cruises you cover up to 8 destinations in one sailing and make the most of your vacation. Every sailing is thoughtfully designed to let you see more, do more, and enjoy more.<br></br><br></br>
TIRUN brought Celebrity Cruises to India some 30 years ago, and we continue to exclusively represent them, in our parts of the world.</p>
        </div>

        <div className="royal-adventure"> 
            
            <div className="content">
            <h2>SUMMER GETAWAYS</h2>
            <p>From discovering the beauty of Europe to exploring Alaska's untouched wilderness, breath-taking beaches of the Caribbean and Bahamas, scenic Australia and New Zealand and amazing Asia we make sure you take in a fresh perspective on the world around you while sailing on the luxurious ships.</p>
            </div>

            <div className="carousel-wrapper" >
      {/* <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}> */}
        <button onClick={handlePrev} style={{backgroundColor:'transparent',border:'none'}} >
          <Pre style={{width:'30px', height:'30px',opacity:'0.3'}}/>
        </button>

        <div className="trip" style={{ display: 'flex', gap: '20px' , transition: 'transform 0.5s ease-in-out'}}>
           {/* <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=8&Destinations=16,39,40,41,18&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer" >  <Deal img={Dealdata[4].img } Dealname={Dealdata[4].Dealname}   /></a> */}
           {/* <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=1&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer"> <Deal img={Dealdata[8].img } Dealname={Dealdata[8].Dealname}  /></a>    */}
           {/* <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=1&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer"> <Deal img={Dealdata[18].img } Dealname={Dealdata[18].Dealname}  /></a>    */}
           {visibleDeals.map((deal, i) => (
          <a
            key={i}
            href={deal.link[Currency.currencyCode]}
            target="_self"
            rel="noopener noreferrer"
            style={{ flex: '1', textDecoration: 'none' }}
          >
            <Deal img={deal.img} Dealname={deal.Dealname} />
          </a>
        ))}
        </div>
        <button
          onClick={handleNext} style={{backgroundColor:'transparent',border:'none'}} 
        >
         <Next style={{width:'30px', height:'30px', opacity:'0.3'}}/>
        </button>
        
        </div>
        </div>

        <div className="royal-adventure celebrity-adventure"  style={{marginTop:'20vh'}}> 
            
            <div className="content">
            <h2>FIND YOUR EXPEDITION</h2>
            <p>Explore the world's most unique and remote destinations.
From the wildlife-rich Galapagos Islands to the frozen wilderness of Antarctica, our expedition cruises offer an unparalleled opportunity to discover the natural
wonders of the planet.</p>
            </div>

            <div className="carousel-wrapper" >
      {/* <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}> */}
        <button onClick={ehandlePrev} style={{backgroundColor:'transparent',border:'none'}} >
          <Pre style={{width:'30px', height:'30px',opacity:'0.3'}}/>
        </button>

        <div className="trip" style={{ display: 'flex', gap: '20px' , transition: 'transform 0.5s ease-in-out'}}>
           {/* <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=8&Destinations=16,39,40,41,18&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer" >  <Deal img={Dealdata[4].img } Dealname={Dealdata[4].Dealname}   /></a> */}
           {/* <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=1&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer"> <Deal img={Dealdata[8].img } Dealname={Dealdata[8].Dealname}  /></a>    */}
           {/* <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=1&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer"> <Deal img={Dealdata[18].img } Dealname={Dealdata[18].Dealname}  /></a>    */}
           {evisibleDeals.map((deal, i) => (
          <a
            key={i}
            href={deal.link[Currency.currencyCode]}
            target="_self"
            rel="noopener noreferrer"
            style={{ flex: '1', textDecoration: 'none' }}
          >
            <Deal img={deal.img} Dealname={deal.Dealname} />
          </a>
        ))}
        </div>
        <button
          onClick={ehandleNext} style={{backgroundColor:'transparent',border:'none'}} 
        >
         <Next style={{width:'30px', height:'30px', opacity:'0.3'}}/>
        </button>
        {/* <div className="trip">
           <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=8&Destinations=16,39,40,41,18&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer" >  <Deal img={Dealdata[9].img } Dealname={Dealdata[9].Dealname}   /></a>
           <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=1&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer"> <Deal img={Dealdata[10].img } Dealname={Dealdata[10].Dealname}  /></a>   
        </div> */}
        </div>
        </div>

        {/* <div className="COCOCAY-container">
            <h2 className="Heading">Adventure for the Whole Pack</h2>
            <div className="cococay-heading" > 
            <h2>PERFECT DAY AT COCOCAY</h2>
            <button>View Itineraries</button>
            </div>
            </div> */}

         <div className="Celebrity-Offer-contaniner">
          <div className="content">
            <h2 className="Heading" style={{fontSize:'2.5rem'}}>NOTHING COMES CLOSE</h2>
            <h2 className="Heading" style={{fontSize:'1rem',fontWeight:'500',lineHeight:'1.5'}}>Celebrity Cruises offers the perfect blend of intimate luxury and big-ship excitement — designed to elevate every moment at sea</h2>
            {/* <div className="cococay-heading" > 
            <h2>PERFECT DAY AT COCOCAY</h2>
            <button>View Itineraries</button>
            </div> */}
            </div>
            <div id="carouselExampleIndicators11" class="carousel slide "  data-bs-ride="carousel" data-bs-interval="4000">

{/* <div className="header-image">
 <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=8&Destinations=16,39,40,41,18&sortColumn=cruiselinePriority&sortOrder=asc" target="_self" rel="noopener noreferrer"> <img src={slide3} alt="Royal Caribbean" style={{cursor:'pointer'}}/></a>
 </div> */}
<div class="carousel-indicators">
<button type="button" data-bs-target="#carouselExampleIndicators11" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
<button type="button" data-bs-target="#carouselExampleIndicators11" data-bs-slide-to="1" aria-label="Slide 2"></button>
<button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
<button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button>
<button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="4" aria-label="Slide 5"></button>
{/* <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="5" aria-label="Slide 6"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="6" aria-label="Slide 7"></button> */}


</div>
<div class="carousel-inner celebrity-inner celebrity-offer">
<div class="carousel-item active ">
{/* <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&cruiseline=2&destinationtype=All&sortColumn=cruiselinePriority&sortOrder=asc" target="_self" rel="noopener noreferrer"> */}
<img src={CelebrityOffer1} class="d-block w-100 " alt="..." />
{/* </a> */}
</div>
<div class="carousel-item ">
{/* <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&cruiseline=2&destinationtype=All&sortColumn=cruiselinePriority&sortOrder=asc" target="_self" rel="noopener noreferrer"> */}
<img src={CelebrityOffer2} class="d-block w-100 " alt="..." sty/>
{/* </a> */}
</div>
 {/* <div class="carousel-item ">
<img src={CelebrityOffer3} class="d-block w-100" alt="..."/>
</div> */}
 <div class="carousel-item ">
<img src={CelebrityOffer4} class="d-block w-100" alt="..."/>
</div> 
{/* <div class="carousel-item ">
<img src={CelebrityOffer5} class="d-block w-100" alt="..."/>
</div>  */}
<div class="carousel-item ">
<img src={CelebrityOffer6} class="d-block w-100" alt="..."/>
</div> 
<div class="carousel-item ">
<img src={CelebrityOffer7} class="d-block w-100" alt="..."/>
</div> 
</div>


<button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators11" data-bs-slide="prev">
<span class="carousel-control-prev-icon" aria-hidden="true"></span>
<span class="visually-hidden">Previous</span>
</button>
<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators11" data-bs-slide="next">
<span class="carousel-control-next-icon" aria-hidden="true"></span>
<span class="visually-hidden">Next</span>
</button>
</div>
            </div>


        <div className="royal-experience celebrity-experience" >

            <h2>THE CELEBRITY EXPERIENCE</h2>

            <div className="royal-exp-card">
            <div className="experience">
            <img src={Sailing} alt="royal-caribbean-experience" />
            <p>VISIT UP TO 8 DESTINATIONS IN ONE SAILING</p>
            </div>
            <div className="experience exceptional">
            <img src={Spa} alt="royal-caribbean-experience" />
            <p>RELAX IN THE LARGEST & MOST COMPREHENSIVE SPA AT SEA</p>
            </div>
            <div className="experience">
            <img src={Wine} alt="royal-caribbean-experience" />
            <p>LARGEST WINE COLLECTION AT SEA</p>
            </div>
            </div>

            <div className="royal-exp-card">   
            <div className="experience">
            <img src={Chef} alt="royal-caribbean-experience"  />
            <p>GLOBALLY INSPIRED CUISINE CURATED BY Michelin-Starred CHEFS</p>
            </div>
            <div className="experience">
            <img  src={Guest} alt="royal-caribbean-experience" />
            <p>WITH ONE STAFF MEMBER FOR NEARLY EVERY TWO GUESTS</p>
            </div>
            <div className="experience">
            <img src={CInterior} alt="royal-caribbean-experience" />
            <p>SPACES DESIGNED BY WORLD- RENOWNED ARCHITECTS AND DESIGNERS</p>
            </div>
            </div>
            
        </div>


        <div className="royal-adventure"> 
            
            <div className="content">
            <h2>THE SUITE CLASS
            EXPERIENCE</h2>
            <p>If privilege, exclusivity and pampering is what you seek on your vacation, there's nothing quite like Suite Class on
Celebrity Cruises. Enjoy the finest living experience at sea, with exclusive access and unparalleled service pampering you with gourmet private dining and five-star amenities designed to exceed your expectations.
Celebrity's Suite Class comes with all perks included which means your beverages, gratuities and some shopping money</p>
            </div>
        {/* <div className="ship">
          <img src={Celebrityship} alt="Royal Caribbean at Sea" />
        </div> */}

        {/* suit experience */}

                    {/* <div class= "Celebrity-suite-container"> */}
            <div id="carouselExampleIndicators2" class="carousel slide Celebrity-suite-carousel">


        <div class="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="2" aria-label="Slide 3"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="3" aria-label="Slide 4"></button>

  </div>
  <div class="carousel-inner celebrity-suite-carousel">
    <div class="carousel-item active">
      <img src={ISMaster} class="d-block w-100" alt="..."  />
    </div>
    <div class="carousel-item">
      <img src={ISLiving} class="d-block w-100" alt="..."  />
    </div>
    <div class="carousel-item">
      <img src={ISBed} class="d-block w-100" alt="..." />
    </div>
    <div class="carousel-item">
      <img src={ISBalcony} class="d-block w-100" alt="..." />
    </div>
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
  </div>
  {/* </div> */}

        </div>

        
        {/* <div className="royal-adventure"> 
            
            <div className="content">
            <h2>CRUISE THE WORLD LIKE A VIP</h2>
            <p>Experience the most immersive luxury experiences with Royal Caribbean's Royal Suite Class Program. From the most exquisitely-appointed accommodations to the best-in-class on-board amenities, the suite-tier program promises an experience that is exclusive. With three service levels, Star Class, Sky Class and Sea Class, you can choose the amenities and special touches according to your specific preferences. Personalized service and the Royal Genie, together make up the most indulgent and exciting cruise holiday ever! After all, luxury is anything but boring.</p>
            </div>
        <div className="suite">
          <img src={VipSuite} alt="Royal Caribbean at Sea" />
        </div>

        </div> */}



 <div className="Cabin-container Laptop-res-accom" >

            <h2>ACCOMODATION</h2>

            <div className="Cabin">
            <div className="royal-cabin">
                
                <div className="cabin-category">  
                <div id="carouselExampleIndicators3" class="carousel slide  royal-category-carousel">


<div class="carousel-indicators">
<button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
<button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="1" aria-label="Slide 2"></button>
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="2" aria-label="Slide 3"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="3" aria-label="Slide 4"></button> */}

</div>
<div class="carousel-inner royal-inner">
<div class="carousel-item active suite-images">
<img src={Veranda1} class="d-block w-100" alt="..."  />
</div>
<div class="carousel-item">
<img src={Veranda2} class="d-block w-100" alt="..."  />
</div>
{/* <div class="carousel-item">
<img src={ISBed} class="d-block w-100" alt="..." />
</div>
<div class="carousel-item">
<img src={ISBalcony} class="d-block w-100" alt="..." />
</div> */}
</div>
<button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide="prev">
<span class="carousel-control-prev-icon" aria-hidden="true"></span>
<span class="visually-hidden">Previous</span>
</button>
<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide="next">
<span class="carousel-control-next-icon" aria-hidden="true"></span>
<span class="visually-hidden">Next</span>
</button>
</div>
                {/* <img src={Interior} alt="Royal Caribbean Accomodation" /> */}
                <div className="category-name">
                VERANDA CABIN
                </div>
                
                {/* <img src={Infinite} alt="Royal Caribbean Accomodation" />
                <div className="category-name" style={{textAlign:'center'}}>
                    VERANDA CABIN
                </div> */}
                </div>

                <div className="cabin-category">  
                <div id="carouselExampleIndicators4" class="carousel slide  royal-category-carousel">


<div class="carousel-indicators">
<button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
<button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="1" aria-label="Slide 2"></button>
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="2" aria-label="Slide 3"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="3" aria-label="Slide 4"></button> */}

</div>
<div class="carousel-inner royal-inner">
<div class="carousel-item active suite-images">
<img src={SkySuite1} class="d-block w-100" alt="..."  />
</div>
<div class="carousel-item">
<img src={SkySuite2} class="d-block w-100" alt="..."  />
</div>
{/* <div class="carousel-item">
<img src={ISBed} class="d-block w-100" alt="..." />
</div>
<div class="carousel-item">
<img src={ISBalcony} class="d-block w-100" alt="..." />
</div> */}
</div>
<button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide="prev">
<span class="carousel-control-prev-icon" aria-hidden="true"></span>
<span class="visually-hidden">Previous</span>
</button>
<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide="next">
<span class="carousel-control-next-icon" aria-hidden="true"></span>
<span class="visually-hidden">Next</span>
</button>
</div>
                {/* <img src={Interior} alt="Royal Caribbean Accomodation" /> */}
                <div className="category-name">
                SKY SUITE
                </div>
                {/* <img src={SkySuite} alt="Royal Caribbean Accomodation" />
                <div className="category-name">
                   SKY SUITE
                </div> */}
                </div>
            </div>

            <div className="royal-cabin">

            <div className="cabin-category">  
            <div id="carouselExampleIndicators5" class="carousel slide  royal-category-carousel">


<div class="carousel-indicators">
<button type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
<button type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide-to="1" aria-label="Slide 2"></button>
<button type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide-to="2" aria-label="Slide 3"></button>
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="3" aria-label="Slide 4"></button> */}

</div>
<div class="carousel-inner royal-inner">
<div class="carousel-item active suite-images">
<img src={Edgevilla1} class="d-block w-100" alt="..."  />
</div>
<div class="carousel-item">
<img src={Edgevilla2} class="d-block w-100" alt="..."  />
</div>
 <div class="carousel-item">
<img src={Edgevilla3} class="d-block w-100" alt="..." />
</div> 
{/* <div class="carousel-item">
<img src={ISBalcony} class="d-block w-100" alt="..." />
</div>  */}
</div>
<button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide="prev">
<span class="carousel-control-prev-icon" aria-hidden="true"></span>
<span class="visually-hidden">Previous</span>
</button>
<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide="next">
<span class="carousel-control-next-icon" aria-hidden="true"></span>
<span class="visually-hidden">Next</span>
</button>
</div>
                {/* <img src={Interior} alt="Royal Caribbean Accomodation" /> */}
                <div className="category-name">
                EDGE VILLA
                </div>
                {/* <img src={Edgevilla} alt="Royal Caribbean Accomodation" />
                <div className="category-name">
                EDGE VILLA
                </div> */}
                </div>

                <div className="cabin-category"> 
                <div id="carouselExampleIndicators6" class="carousel slide  royal-category-carousel">


<div class="carousel-indicators">
<button type="button" data-bs-target="#carouselExampleIndicators6" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
<button type="button" data-bs-target="#carouselExampleIndicators6" data-bs-slide-to="1" aria-label="Slide 2"></button>
<button type="button" data-bs-target="#carouselExampleIndicators6" data-bs-slide-to="2" aria-label="Slide 3"></button>
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="3" aria-label="Slide 4"></button> */}

</div>
<div class="carousel-inner royal-inner">
<div class="carousel-item active suite-images">
<img src={Penthouse1} class="d-block w-100" alt="..."  />
</div>
<div class="carousel-item">
<img src={Penthouse2} class="d-block w-100" alt="..."  />
</div>
<div class="carousel-item">
<img src={Penthouse3} class="d-block w-100" alt="..." />
</div>
{/* <div class="carousel-item">
<img src={ISBalcony} class="d-block w-100" alt="..." />
</div>  */}
</div>
<button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators6" data-bs-slide="prev">
<span class="carousel-control-prev-icon" aria-hidden="true"></span>
<span class="visually-hidden">Previous</span>
</button>
<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators6" data-bs-slide="next">
<span class="carousel-control-next-icon" aria-hidden="true"></span>
<span class="visually-hidden">Next</span>
</button>
</div>
                {/* <img src={Interior} alt="Royal Caribbean Accomodation" /> */}
                <div className="category-name">
                PENTHOUSE SUITE
                </div> 
                {/* <img src={Penthouse} alt="Royal Caribbean Accomodation" />
                <div className="category-name">
                PENTHOUSE SUITE
                </div> */}

                </div>


            </div>

            </div>
            
        </div>




{/* Mobile Accomodation */}

        <div className="Cabin-container-mobile mobile-res-accom" >

<h2>ACCOMODATION</h2>

<div className="Cabin-mobile">
<div className="royal-cabin-mobile">
    
    <div className="cabin-category-mobile">  
    <div className="cabin-category mobile-responsive-royal-category">  

<div id="carouselExampleIndicators7" class="carousel slide  royal-category-carousel">


<div class="carousel-indicators">
<button type="button" data-bs-target="#carouselExampleIndicators7" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
<button type="button" data-bs-target="#carouselExampleIndicators7" data-bs-slide-to="1" aria-label="Slide 2"></button>
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="2" aria-label="Slide 3"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="3" aria-label="Slide 4"></button> */}

</div>
<div class="carousel-inner royal-inner">
<div class="carousel-item active suite-images">
<img src={Veranda1} class="d-block w-100" alt="..."  />
</div>
<div class="carousel-item">
<img src={Veranda2} class="d-block w-100" alt="..."  />
</div>
{/* <div class="carousel-item">
<img src={ISBed} class="d-block w-100" alt="..." />
</div>
<div class="carousel-item">
<img src={ISBalcony} class="d-block w-100" alt="..." />
</div> */}
</div>
<button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators7" data-bs-slide="prev">
<span class="carousel-control-prev-icon" aria-hidden="true"></span>
<span class="visually-hidden">Previous</span>
</button>
<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators7" data-bs-slide="next">
<span class="carousel-control-next-icon" aria-hidden="true"></span>
<span class="visually-hidden">Next</span>
</button>
</div>
{/* <img src={Interior} alt="Royal Caribbean Accomodation" /> */}
<div className="category-name">
    VERANDA CABIN
</div>
</div>
    {/* <img src={Infinite} alt="Royal Caribbean Accomodation" />
    <div className="category-name-mobile" style={{textAlign:'center'}}>
        VERANDA CABIN
    </div> */}
    </div>


    <div className="cabin-category mobile-responsive-royal-category"> 
                <div id="carouselExampleIndicators8" class="carousel slide ">


<div class="carousel-indicators">
<button type="button" data-bs-target="#carouselExampleIndicators8" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
<button type="button" data-bs-target="#carouselExampleIndicators8" data-bs-slide-to="1" aria-label="Slide 2"></button>
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="2" aria-label="Slide 3"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="3" aria-label="Slide 4"></button> */}

</div>
<div class="carousel-inner royal-inner ">
<div class="carousel-item active">
<img src={SkySuite1} class="d-block w-100" alt="..."  />
</div>
<div class="carousel-item">
<img src={SkySuite2} class="d-block w-100" alt="..."  />
</div>
 {/* <div class="carousel-item">
<img src={ISBed} class="d-block w-100" alt="..." />
</div> */}
{/* <div class="carousel-item">
<img src={ISBalcony} class="d-block w-100" alt="..." />
</div>  */}
</div>
<button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators8" data-bs-slide="prev">
<span class="carousel-control-prev-icon" aria-hidden="true"></span>
<span class="visually-hidden">Previous</span>
</button>
<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators8" data-bs-slide="next">
<span class="carousel-control-next-icon" aria-hidden="true"></span>
<span class="visually-hidden">Next</span>
</button>
</div> 
                {/* <img src={Ocean} alt="Royal Caribbean Accomodation" /> */}
                <div className="category-name">
                   SKY SUITE
                </div>
                </div>
    {/* <div className="cabin-category-mobile">  
    <img src={SkySuite} alt="Royal Caribbean Accomodation" />
    <div className="category-name-mobile" style={{textAlign:'center'}}>
       SKY SUITE
    </div>
    </div> */}
</div>

<div className="royal-cabin-mobile">

<div className="cabin-category-mobile"> 
<div className="cabin-category mobile-responsive-royal-category">  
            <div id="carouselExampleIndicators9" class="carousel slide ">


<div class="carousel-indicators">
<button type="button" data-bs-target="#carouselExampleIndicators9" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
<button type="button" data-bs-target="#carouselExampleIndicators9" data-bs-slide-to="1" aria-label="Slide 2"></button>
<button type="button" data-bs-target="#carouselExampleIndicators9" data-bs-slide-to="2" aria-label="Slide 3"></button>
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="3" aria-label="Slide 4"></button> */}

</div>
<div class="carousel-inner royal-inner">
<div class="carousel-item active">
<img src={Edgevilla1} class="d-block w-100" alt="..."  />
</div>
<div class="carousel-item">
<img src={Edgevilla2} class="d-block w-100" alt="..."  />
</div>
<div class="carousel-item">
<img src={Edgevilla3} class="d-block w-100" alt="..." />
</div>
{/* <div class="carousel-item">
<img src={ISBalcony} class="d-block w-100" alt="..." />
</div> */}
</div>
<button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators9" data-bs-slide="prev">
<span class="carousel-control-prev-icon" aria-hidden="true"></span>
<span class="visually-hidden">Previous</span>
</button>
<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators9" data-bs-slide="next">
<span class="carousel-control-next-icon" aria-hidden="true"></span>
<span class="visually-hidden">Next</span>
</button>
</div>
                {/* <img src={Balcony} alt="Royal Caribbean Accomodation" /> */}
                <div className="category-name">
                    EDGE VILLA
                </div>
                </div> 
    {/* <img src={Edgevilla} alt="Royal Caribbean Accomodation" />
    <div className="category-name-mobile" style={{textAlign:'center'}}>
    EDGE VILLA
    </div> */}
    </div>

    <div className="cabin-category-mobile"> 
    <div className="cabin-category mobile-responsive-royal-category">  
            <div id="carouselExampleIndicators10" class="carousel slide ">


<div class="carousel-indicators">
<button type="button" data-bs-target="#carouselExampleIndicators10" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
<button type="button" data-bs-target="#carouselExampleIndicators10" data-bs-slide-to="1" aria-label="Slide 2"></button>
<button type="button" data-bs-target="#carouselExampleIndicators10" data-bs-slide-to="2" aria-label="Slide 3"></button>
{/* <button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="3" aria-label="Slide 4"></button> */}

</div>
<div class="carousel-inner royal-inner">
<div class="carousel-item active">
<img src={Penthouse1} class="d-block w-100" alt="..."  />
</div>
<div class="carousel-item">
<img src={Penthouse2} class="d-block w-100" alt="..."  />
</div>
<div class="carousel-item">
<img src={Penthouse3} class="d-block w-100" alt="..." />
</div>
{/* <div class="carousel-item">
<img src={ISBalcony} class="d-block w-100" alt="..." />
</div> */}
</div>
<button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators10" data-bs-slide="prev">
<span class="carousel-control-prev-icon" aria-hidden="true"></span>
<span class="visually-hidden">Previous</span>
</button>
<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators10" data-bs-slide="next">
<span class="carousel-control-next-icon" aria-hidden="true"></span>
<span class="visually-hidden">Next</span>
</button>
</div>
                {/* <img src={Balcony} alt="Royal Caribbean Accomodation" /> */}
                <div className="category-name">
                    PENTHOUSE SUITE
                </div>
                </div> 
    {/* <img src={Penthouse} alt="Royal Caribbean Accomodation" />
    <div className="category-name-mobile" style={{textAlign:'center'}}>
    PENTHOUSE SUITE
    </div> */}

    </div>


</div>

</div>

</div>

        <div className="royal-adventure cc-cruises"> 
            
            <div className="content">
            {/* <p>Luxury Resorts at Sea</p> */}
            <h2>CELEBRITY'S SHIPS</h2>
            <p>Celebrity cruises encourage people to
            sail beyond their own borders and expand their horizons.</p>
            </div>

            <div className="carousel-wrapper" >
      {/* <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}> */}
        <button onClick={cchandlePrev} style={{backgroundColor:'transparent',border:'none'}} >
          <Pre style={{width:'30px', height:'30px',opacity:'0.3'}}/>
        </button>

        <div className="trip" style={{ display: 'flex', gap: '20px' , transition: 'transform 0.5s ease-in-out'}}>
           {/* <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=8&Destinations=16,39,40,41,18&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer" >  <Deal img={Dealdata[4].img } Dealname={Dealdata[4].Dealname}   /></a> */}
           {/* <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=1&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer"> <Deal img={Dealdata[8].img } Dealname={Dealdata[8].Dealname}  /></a>    */}
           {/* <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=1&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer"> <Deal img={Dealdata[18].img } Dealname={Dealdata[18].Dealname}  /></a>    */}
           {ccvisibleDeals.map((deal, i) => (
          <a
            key={i}
            href={deal.link[Currency.currencyCode]}
            target="_self"
            rel="noopener noreferrer"
            style={{ flex: '1', textDecoration: 'none' }}
          >
            <Deal img={deal.img} Dealname={deal.Dealname} />
          </a>
        ))}
        </div>
        <button
          onClick={cchandleNext} style={{backgroundColor:'transparent',border:'none'}} 
        >
         <Next style={{width:'30px', height:'30px', opacity:'0.3'}}/>
        </button>
       

        {/* <div className="trip" style={{marginBottom:'40vh'}}>
           <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=8&Destinations=16,39,40,41,18&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer">  <Deal img={Dealdata[11].img } Dealname={Dealdata[11].Dealname}  /></a>
           <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=1&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer"> <Deal img={Dealdata[12].img } Dealname={Dealdata[12].Dealname}  /></a> */}
           {/* <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=1&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer"> <Deal img={Dealdata[1].img } Dealname={Dealdata[1].Dealname}  /></a> */}

        {/* </div> */}

        </div>

        </div>


        
        <ScrolltoTop/>

        <Footer/>
        
        
        </>
    );
}

export default Celebrity;